<vrm-card [cardTitle]='cardTitle' *ngIf='summaryData' [shadedHeaderLevel]='17'>
  <div class='vrm-card'>
    <div class='margin-10' *ngIf='summaryData.length == 0'>
      <span *ngIf="context === 'activeEvents'">{{ 'CHART.noActiveEvents' | translate }}</span>
      <span *ngIf="context === 'historicEvents'">{{ 'CHART.noHistoricEvents' | translate }}</span>
    </div>

    <div
      class='margin-10'
      *ngIf='(mentorSummaryData && mentorSummaryData?.total == undefined) || mentorSummaryData?.total == 0'
    >
			<span *ngIf="context === 'mentorPlaylistModules'">
				{{ 'GENERIC.noMentorPlaylistModules' | translate }}
			</span>
    </div>

    <mat-accordion displayMode='flat' *ngIf="summaryData.length > 0 && context !== 'mentorPlaylistModules'">
      <mat-expansion-panel
        class='vrm-summary-expansion no-elevation-but-underline'
        [disabled]='!summary.data.data.length'
        [hideToggle]='!summary.data.data.length'
        *ngFor='let summary of summaryData; let i = index'
      >
        <mat-expansion-panel-header>
          <div
            class='padding-t-5 margin-r-15 padding-l-5 bold'
            [style.font-size]="cService.isPcViewport ? '16px' : '70%'"
            [style.min-width]="cService.isPcViewport ? '100px' : '50px'"
          >
            {{
            translate.instant('CHART')[summary.eventType]
              ? translate.instant('CHART')[summary.eventType]
              : summary.eventType
            }}
          </div>

          <div
            class='custom-chips-container'
            style='font-size: 85%'
            fxLayout='row'
            fxLayoutAlign='space-between'
          >
            <div
              [class.green-color]="summary.eventsLast30Days == 0 && context === 'activeEvents'"
              matTooltip="{{ summary.eventsLast30Days }} {{ 'GENERIC.events' | translate }} {{
								'DASHBOARD.last30Days' | translate
							}}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ summary.eventsLast30Days }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ summary.eventsLast30Days }}</span
                >&nbsp;<span>{{ 'GENERIC.events' | translate }}</span>
                {{ 'DASHBOARD.last30Days' | translate }}
							</span>
            </div>

            <div
              [class.green-color]="summary.events == 0 && context === 'activeEvents'"
              matTooltip="{{ summary.events }} {{ 'GENERIC.events' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ summary.events }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ summary.events }}</span
                >&nbsp;{{ 'GENERIC.events' | translate }}
							</span>
            </div>

            <div
              [class.green-color]="summary.indexSubscore == 0 && context === 'activeEvents'"
              matTooltip="{{ summary.indexSubscore }} {{ 'GENERIC.indexSubScore' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ summary.indexSubscore }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ summary.indexSubscore }}</span>
                {{ 'GENERIC.indexSubScore' | translate }} <span></span>
							</span>
            </div>

            <div
              [class.red-color]='summary.percentIndex > 50'
              matTooltip="{{ summary.percentIndex }}% {{ 'GENERIC.ofIndexScore' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ summary.percentIndex }}%</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ summary.percentIndex }}%</span>
                {{ 'GENERIC.ofIndexScore' | translate }} <span></span>
							</span>
            </div>
          </div>
        </mat-expansion-panel-header>

        <!-- Body - PC & Mobile -->
        <div *ngIf='summary.data.data.length > 0'>
          <div *ngFor='let entry of summary.data.data'>
            <table class='raw-table'>
              <tr>
                <td>{{ 'GENERIC.date' | translate }}</td>
                <td>{{ entry.date }}</td>
              </tr>

              <tr>
                <td>{{ 'GENERIC.eventCode' | translate }}</td>
                <td>{{ this.cService.getSingleTranslation('EVENT_DESCRIPTIONS.' + entry.eventCode, entry.eventCode)  }}</td>
              </tr>

              <tr>
                <td>{{ 'GENERIC.description' | translate }}</td>
                <td style='word-break: break-word'>{{ entry.description }}</td>
              </tr>

              <tr>
                <td>{{ 'GENERIC.value' | translate }}</td>
                <td>
                  {{ entry.value | numberToDecimalPlaces }}
                  <span *ngIf='entry.isOverridden' class='override-applied'>{{
                    'GENERIC.overrideApplied' | translate
                    }}</span>
                </td>
              </tr>
            </table>

            <vrm-index-override
              *ngIf='
								cService.userProfile.userPermissions.permIndexOverride ==
									cService.permLevels.override ||
								cService.userProfile.userPermissions.permIndexOverride == cService.permLevels.view
							'
              [theIncident]='entry'
              [allIncidents]='summaryData'
              (vrmIndexOverrideChange)='updateEntry($event, entry)'
            ></vrm-index-override>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-container *ngIf='licenseEventsHidden'>
      <small class='absent-event-text' *ngIf="context === 'activeEvents'">
        {{ 'GENERIC.driverIndexScoreMayIncludeEventsNotPermittedToView_ActiveEvents' | translate }}
      </small>

      <small class='absent-event-text' *ngIf="context === 'historicEvents'">
        {{ 'GENERIC.driverIndexScoreMayIncludeEventsNotPermittedToView_HistoricalEvents' | translate }}
      </small>
    </ng-container>

    <!-- Mentor Playlist -->
    <mat-accordion
      *ngIf="context === 'mentorPlaylistModules' &&
				mentorSummaryData &&
				mentorSummaryData.total != undefined &&
				mentorSummaryData.total > 0
			"
      displayMode='flat'
    >
      <mat-expansion-panel class='vrm-summary-expansion no-elevation-but-underline'>
        <mat-expansion-panel-header>
          <div
            class='padding-t-5 margin-r-15 padding-l-5 bold'
            [style.font-size]="cService.isPcViewport ? '16px' : '70%'"
            [style.min-width]="cService.isPcViewport ? '100px' : '50px'"
          >
            {{ 'GENERIC.mentorPlaylist' | translate | titlecase }}
          </div>

          <div
            class='custom-chips-container'
            style='font-size: 85%'
            fxLayout='row'
            fxLayoutAlign='space-between'
          >
            <div matTooltip="{{ mentorSummaryData.total }} {{ 'GENERIC.assigned' | translate }}">
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ mentorSummaryData.total }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ mentorSummaryData.total }}</span
                >&nbsp;<span>{{ 'GENERIC.assigned' | translate }}</span>
							</span>
            </div>

            <div matTooltip="{{ mentorSummaryData.completed }} {{ 'DASHBOARD.completed' | translate }}">
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ mentorSummaryData.completed }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ mentorSummaryData.completed }}</span
                >&nbsp;<span>{{ 'DASHBOARD.completed' | translate }}</span>
							</span>
            </div>

            <div
              [class.green-color]='mentorSummaryData.total - mentorSummaryData.completed == 0'
              [class.red-color]='mentorSummaryData.total - mentorSummaryData.completed > 0'
              matTooltip="{{ mentorSummaryData.total - mentorSummaryData.completed }} {{
								'REPORTDATA.notStarted' | translate
							}}"
            >
							<span *ngIf='!cService.isPcViewport' class='bold'>{{
                mentorSummaryData.total - mentorSummaryData.completed
                }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ mentorSummaryData.total - mentorSummaryData.completed }} </span
                >&nbsp;<span>{{ 'REPORTDATA.notStarted' | translate }}</span>
							</span>
            </div>
          </div>
        </mat-expansion-panel-header>

        <!-- Body - PC & Mobile -->
        <div *ngIf='driverModules.data.length'>
          <table class='raw-table' *ngFor='let playlist of driverModules.data'>
            <tr>
              <td>{{ 'REPORTDATA.playlistItem' | translate }}</td>
              <td>
                <strong>{{ playlist.category }}</strong>
                <span class='playlist-name'>{{ playlist.name }}</span>
              </td>
            </tr>

            <tr>
              <td>{{ 'REPORTDATA.dateAssigned' | translate }}</td>
              <td>{{ playlist.createdOn | date: 'yyyy-MM-dd' }}</td>
            </tr>

            <tr>
              <td>{{ 'REPORTDATA.status' | translate }}</td>
              <td [class.complete]='playlist.completedOn' [class.not-started]='!playlist.completedOn'>
                <strong *ngIf='playlist.completedOn'>{{ 'REPORTDATA.complete' | translate }}</strong>
                <strong *ngIf='!playlist.completedOn'>{{ 'REPORTDATA.notStarted' | translate }}</strong>
              </td>
            </tr>

            <tr *ngIf='playlist.completedOn'>
              <td>{{ 'REPORTDATA.dateCompleted' | translate }}</td>
              <td>{{ playlist.completedOn | date: 'yyyy-MM-dd' }}</td>
            </tr>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</vrm-card>
